import React, { createContext, useContext, useState } from 'react';
import { translations, translateError } from './translations';

const LangContext = createContext();

export function LangProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem('lang') || 'pl');

  const t = (key) => {
    const val = translations[lang]?.[key] ?? translations.pl[key];
    return val !== undefined ? val : key;
  };

  const tErr = (msg) => translateError(msg, lang);

  const changeLang = (l) => {
    setLang(l);
    localStorage.setItem('lang', l);
  };

  return (
    <LangContext.Provider value={{ lang, t, tErr, changeLang }}>
      {children}
    </LangContext.Provider>
  );
}

export const useLang = () => useContext(LangContext);
